import { Sparkles } from "lucide-react";

export const SundayBanner = ({ className = "" }) => (
  <div className={`flex items-center gap-3 rounded-2xl bg-amber-50 border border-amber-200 px-4 py-3 ${className}`} data-testid="sunday-womens-banner">
    <span className="h-9 w-9 rounded-xl bg-[#DC2626] text-white grid place-items-center shrink-0"><Sparkles className="h-4 w-4" /></span>
    <div>
      <p className="font-semibold text-[#1F2937] text-sm">30% off for women's on Sundays</p>
      <p className="text-xs text-[#4B5563]">Applies to consultation fees every Sunday</p>
    </div>
  </div>
);
